import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { BankStatementDashboard } from '@roc/feature-bank-statements';
import { Layout } from '@roc/client-portal-shared/components';

const bankStatementsRoutesConfig = (basePath: string, baseUrl: string) => ({
  bankStatements: {
    path: `${basePath}/bank-statements`,
    url: `${baseUrl}/bank-statements`,
    documentTitle: 'Borrower Liquidity',
  },
});

export const getBankStatementsInternalRoutes = (
  basePath: string,
  baseUrl: string,
  loanId: string,
  borrowerId: string
) => {
  const config = bankStatementsRoutesConfig(basePath, baseUrl);

  return {
    bankStatements: (
      <Route exact path={config.bankStatements.path}>
        <Page routeDefinition={config.bankStatements}>
          <Layout title="Borrower Liquidity">
            <BankStatementDashboard
              loanId={Number(loanId)}
              borrowerId={Number(borrowerId)}
              fromSummary
            />
          </Layout>
        </Page>
      </Route>
    ),
  };
};
